import React, { Component } from "react";
import { observer } from "mobx-react";

import UsersListRow from "./UsersListRow";

export default observer(
  class UsersList extends Component {
    render() {
      const { usersStore, stores, filter } = this.props;

      const filteredRows = usersStore.filter(
        r =>
          filter === "undefined" ||
          !filter ||
          (r.Name &&
            r.Name.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
          (r.Email &&
            r.Email.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
      );

      let rows = null;
      if (filteredRows) {
        rows = filteredRows.map(user => {
          return <UsersListRow key={user.Id} user={user} stores={stores} />;
        });
      }

      return (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Last updated</th>
              <th className="col-sm-1" />
              <th className="col-sm-1" />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/UsersList/index.js